<template>
  <v-card
    elevation="0"
    style="border: 1px solid #ebebeb"
    class="mx-6 px-7 py-7 rounded-xl"
  >
    <v-row
      class="d-flex justify-space-between rounded-0"
      style="border-bottom: 1px solid #ebebeb"
    >
      <Chat></Chat>

      <v-col cols="5" class="d-flex align-center">
        <span class="wc-h6 text-primary-variant">
          {{ this.mode === "CREATE" ? "Nueva" : "Editar" }} Publicación
        </span>
      </v-col>
      <v-col cols="7">
        <v-row class="d-flex justify-end">
          <v-col cols="auto" class="d-flex flex-grow-0 align-center justify-end">
            <v-btn
              :disabled="disableSaveButton"
              :color="color.secondary"
              elevation="0"
              class="rounded-xl wc text-primary-variant text-capitalize px-7"
              style="font-weight: 700"
              @click="confirmDialog = true"
            >
              Guardar
            </v-btn>
          </v-col>
          <!-- Botón vista previa de la entrada -->
          <v-col cols="auto" class="d-flex flex-grow-0 align-center justify-center">
            <v-btn
              class="rounded-xl"
              elevation="1"
              text
              @click="previewDialog = true"
            >
              <v-icon class="mx-3" :color="color.primaryVariant"
                >mdi-monitor-eye</v-icon
              >
              <span class="text-primary-variant" style="font-weight: 700"
                >Vista previa</span
              >
            </v-btn>
          </v-col>
          <v-col cols="auto" class="flex-grow-0">
            <span style="font-weight: 700"> Estado </span>
            <div class="d-flex align-center justify-space-between">
              <span
                style="font-size: 11px; font-weight: 500; margin-right: 13px"
              >
                {{ setPublicationStatus ? "Publicado" : "Archivado" }}
              </span>
              <v-switch
                :color="color.primaryVariant"
                dense
                hide-details=""
                class="ma-0"
                v-model="setPublicationStatus"
              ></v-switch>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="9" style="border-right: 1px solid #ebebeb">
        <div v-if="setPublicationType === 'BLOG'">
          <blog
            :publicationData="publicationComputed"
            @changeData="handlePost"
          />
        </div>
        <div v-if="setPublicationType === 'VIDEO'">
          <Video
            :publicationData="publicationComputed"
            @changeData="handlePost"
          />
        </div>
        <div v-if="setPublicationType === 'LINK'">
          <Link
            :publicationData="publicationComputed"
            @changeData="handlePost"
          />
        </div>
        <div v-if="setPublicationType === 'DOC'">
          <Doc
            :publicationData="publicationComputed"
            @changeData="handlePost"
          />
        </div>
        <section v-if="setPublicationType === 'POLL'" class="asocoins-poll-editor">
          <div class="asocoins-poll-editor__header">
            <p class="asocoins-poll-editor__eyebrow">Comunicado con participación</p>
            <h2>Configura tu encuesta</h2>
            <p>La encuesta se publicará junto con tus comunicados. Si activas la recompensa, cada miembro podrá responderla una vez.</p>
          </div>

          <label class="asocoins-poll-editor__field">
            <span>Título del comunicado</span>
            <input v-model="publication.name" type="text" placeholder="Ej. Diagnóstico de necesidades" />
          </label>

          <label class="asocoins-poll-editor__field">
            <span>Descripción (opcional)</span>
            <textarea v-model="publication.description" rows="3" placeholder="Explica el propósito de la encuesta"></textarea>
          </label>

          <div class="asocoins-poll-editor__questions">
            <div class="asocoins-poll-editor__questions-head">
              <div>
                <span class="asocoins-poll-editor__label">Preguntas</span>
                <small>Agrega las preguntas y opciones que verán los miembros.</small>
              </div>
              <button class="asocoins-poll-editor__button" type="button" @click="addPollQuestion">
                + Agregar pregunta
              </button>
            </div>

            <article v-for="(question, questionIndex) in pollQuestions" :key="questionIndex" class="asocoins-poll-editor__question">
              <div class="asocoins-poll-editor__question-head">
                <span>Pregunta {{ questionIndex + 1 }}</span>
                <button
                  v-if="pollQuestions.length > 1"
                  class="asocoins-poll-editor__remove"
                  type="button"
                  @click="removePollQuestion(questionIndex)"
                >
                  Eliminar
                </button>
              </div>
              <label class="asocoins-poll-editor__field">
                <span class="sr-only">Texto de la pregunta {{ questionIndex + 1 }}</span>
                <input v-model="question.text" type="text" placeholder="Escribe la pregunta" />
              </label>
              <div class="asocoins-poll-editor__options">
                <div class="asocoins-poll-editor__options-head">
                  <span>Opciones de respuesta</span>
                  <button class="asocoins-poll-editor__button asocoins-poll-editor__button--small" type="button" @click="addPollOption(questionIndex)">
                    + Agregar opción
                  </button>
                </div>
                <div v-for="(option, optionIndex) in question.options" :key="optionIndex" class="asocoins-poll-editor__option">
                  <input v-model="question.options[optionIndex]" type="text" :placeholder="`Opción ${optionIndex + 1}`" />
                  <button
                    v-if="question.options.length > 1"
                    class="asocoins-poll-editor__remove"
                    type="button"
                    :aria-label="`Eliminar opción ${optionIndex + 1}`"
                    @click="removePollOption(questionIndex, optionIndex)"
                  >
                    ×
                  </button>
                </div>
              </div>
            </article>
          </div>

          <label class="asocoins-poll-editor__check">
            <input v-model="publication.asocoinsSurvey.enabled" type="checkbox" />
            <span>Otorgar recompensa en Asocoins al responder</span>
          </label>

          <div v-if="publication.asocoinsSurvey.enabled" class="asocoins-poll-editor__reward">
            <label class="asocoins-poll-editor__field">
              <span>Importe base (500–1,500 Asocoins)</span>
              <input v-model.number="publication.asocoinsSurvey.baseAmount" type="number" min="500" max="1500" />
            </label>
            <div class="asocoins-poll-editor__dates">
              <label class="asocoins-poll-editor__field">
                <span>Inicio (opcional)</span>
                <input v-model="publication.asocoinsSurvey.startsAt" type="date" />
              </label>
              <label class="asocoins-poll-editor__field">
                <span>Cierre (opcional)</span>
                <input v-model="publication.asocoinsSurvey.closesAt" type="date" />
              </label>
            </div>
          </div>
        </section>
      </v-col>

      <v-col cols="3" class="pa-5">
        <div class="section">
          <span class="wc-5 subtitle">Tipo de Publicación</span>
          <v-select
            filled
            background-color="#f9fafc"
            :items="publicationTypes"
            hide-details
            v-model="publication.type"
          >
          </v-select>
        </div>
        <div class="section">
          <span class="wc-5 subtitle">Etiquetas</span>
          <v-combobox
            hide-selected
            label="Seleccione las etiquetas pertinentes"
            multiple
            background-color="#f9fafc"
            persistent-hint
            hide-details
            small-chips
            filled
            v-model="publication.labels"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    Presiona
                    <kbd>enter</kbd> para crear una nueva opción.
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>
        </div>
        <div class="section">
          <span class="wc-5 subtitle">Sección</span>
          <v-select
            v-model="publication.section"
            :items="publicationSectionOptions"
            item-text="name"
            item-value="_id"
            label="Selecciona una sección"
            filled
            clearable
            hide-details
            background-color="#f9fafc"
          />
        </div>
        <div class="section">
          <span class="wc-5 subtitle">Preferencias de publicación</span>
            <p>
              Configura quienes pueden ver esta publicación seleccionando las preferencias.
            </p>
            <AudienceDialog
              ref="audience_configs"
              :publication="publication._id"
              :editMode="this.mode !== 'CREATE'"
              :hideBranches="!hasChapters"
            />
        </div>

        <!-- Mostrar la sección de notificaciones solo si está Publicado -->
        <!-- <div v-if="false">
          <div class="section">
            <span class="wc-5"
              >¿Como deseas enviar las notificaciones por correo electrónico a los miembros de la organización?</span
            >
              <v-radio-group v-model="selectedOption" row>
                <v-radio v-for="(option, i) of emailConfigOptions" :key="i"
                  :label="option.label"
                  :value="option.value"
                  class="mb-2"
                  />
              </v-radio-group>
          </div>
          <div v-if="mailToGroupSwitch()">
            <v-combobox
              v-model="selectedSubgroups"
              label="¿A qué grupo de miembros deseas enviar notificaciones?"
              :items="subgroups"
              background-color="#f9fafc"
              persistent-hint
              hide-details
              filled
              :multiple="true"
              hide-selected
              small-chips
            >
            </v-combobox>
          </div>
        </div> -->

        <!-- <PersonalizedDialog
          :hideImage="true"
          :dialog="confirmDialog2"
          :dimensions="{ width: 1113 }"
          @save="confirmYes"
          @discard="confirmNo"
        >
          <template #alertName> Confirmación </template>
          <template #alertContent>
            <div class="d-flex justify-center" width="100%">
              ¿Está seguro de que desea enviar la notificación?
            </div>
          </template>
        </PersonalizedDialog> -->

        <div class="section" hidden>
          <span class="wc-5 subtitle">Publicar el</span>
          <v-radio-group v-model="radioGroup">
            <v-radio
              v-for="(item, i) in radioOptions"
              :key="i"
              :value="i"
              :label="item.text"
            >
            </v-radio>
          </v-radio-group>
        </div>
        <div class="section" hidden>
          <span class="wc-5 subtitle">Visible Para</span>
          <v-select background-color="#f9fafc" filled hide-details="">
          </v-select>
        </div>
        <div class="section" hidden>
          <span class="wc-5 subtitle">Permitir Comentarios</span>
          <div class="d-flex justify-center align-center">
            <span> Se permiten comentarios </span>
            <v-switch
              class="ma-0 ml-4"
              hide-details
              dense
              :color="color.secondary"
            ></v-switch>
          </div>
        </div>
        <div class="section" hidden>
          <span class="wc-5 subtitle">Autor de la publicación</span>
          <v-select background-color="#f9fafc" filled hide-details="">
          </v-select>
        </div>
      </v-col>
    </v-row>
    <!-- Ventana emergente para visualizar la publicación -->
    <PersonalizedDialog
      hidden
      :hideButton="true"
      :dimentions="{
        width: 1113,
      }"
      :dialog="previewDialog"
      @save="closePreview"
      @discard="previewDialog = false"
    >
      <template #alertName> Vista previa </template>

      <template #alertContent>
        <div class="d-flex justify-center" width="100%">
          <communityCard
            :posts="[{ ...publicationComputed }]"
            @changePosts="handleChangePost"
          >
          </communityCard>
        </div>
      </template>
    </PersonalizedDialog>

    <!-- Ventana emergente para guardar cambios -->
    <PersonalizedDialog
      hidden
      :hideImage="true"
      :dialog="confirmDialog"
      @save="savePublication"
      @discard="confirmDialog = false"
    >
      <template #alertName>
        <span style="font-weight: 600; color: black">{{
          `${setPublicationStatus ? "Publicar entrada" : "Importante"}`
        }}</span>
      </template>
      <template #alertContent>
        <p class="title text-center">
          {{
            `${
              setPublicationStatus
                ? "¿Estas seguro que deseas publicar la entrada? "
                : `No has activado el switch de "Publicar", si avanzas, tu publicación se guardará en el apartado de INACTIVAS, puedes ajustarlo en cualquier momento.`
            }`
          }}
        </p>
      </template>
      <template #button>
        {{ `${setPublicationStatus ? "Publicar" : "Guardar"}` }}
      </template>
    </PersonalizedDialog>
  </v-card>
</template>

<script>
import Chat from "@/components/shared/Chat.vue";
import axios from "axios";

import { mapActions, mapMutations, mapState } from "vuex";
import { colors } from "@/constants/colors";
import { types } from "@/constants/publicationTypes.js";
import PersonalizedDialog from "@/components/shared/PersonalizedDialog.vue";
import communityCard from "../../components/memberDashboard/memberCommunity/communityCard.vue";
import AudienceDialog from "../../components/dashboard/audienceRules/AudienceDialog.vue";
import Blog from "../../components/dashboard/myCommunity/publicationsViews/Blog.vue";
import Video from "../../components/dashboard/myCommunity/publicationsViews/Video.vue";
import Link from "../../components/dashboard/myCommunity/publicationsViews/Link.vue";
import Doc from "../../components/dashboard/myCommunity/publicationsViews/Doc.vue";
import { hasOrganizationChapters } from "@/common/ampiOrganizationUserAccess";

export default {
  components: {
    Blog,
    Video,
    Link,
    Doc,
    PersonalizedDialog,
    communityCard,
    AudienceDialog,
    Chat,
  },
  data() {
    return {
      company: "",
      emails: [],
      selectedSubgroups: [],
      subgroups: [],
      selectedOption: "cancelNotification", /** sendToEveryone | sendEmailToGroups | cancelNotification */
      emailConfigOptions: [
        {
          label:"Enviar notificación a todos los miembros de la organización",
          value:"sendToEveryone"
        },
        {
          label:"Enviar notificación solo a grupos seleccionados",
          value:"sendEmailToGroups"
        },
        {
          label:"No enviar notificación",
          value:"cancelNotification"
        }
      ],
      confirmOption: false,
      confirmDialog2: false,

      color: colors,
      publicationTypes: types,
      confirmDialog: false,
      previewDialog: false,
      radioGroup: 1,
      saveAction: false,
      radioOptions: [
        { text: "Automáticamente" },
        { text: "Rango de tiempo" },
        { text: "Establecer fecha y hora" },
      ],
      publication: {
        name: "",
        description: "",
        type: "BLOG",
        labels: [],
        images: [],
        status: "",
        value: "",
        status: "PUBLISHED",
        expand: false,
        hideOver: false,
        url: "",
        section: null,
        asocoinsSurvey: {
          enabled: false,
          baseAmount: 1000,
          startsAt: null,
          closesAt: null,
          questions: [],
        },
      },
      pollQuestions: [{ text: "", options: [""] }],
      publicationSections: [],
    };
  },
  async created() {
    //this.realoadUserData({ id: this.company });
    console.log(this.company);
    await Promise.all([this.fetchSubgroups(), this.fetchSections()]);
  },
  methods: {
    ...mapActions("user", ["realoadUserData"]),
    ...mapActions("publications", [
      "fetchPublicationById",
      "updatePublication",
      "createPublication",
      "deletePublication",
    ]),
    ...mapActions("asocoins", ["configureSurvey"]),
    ...mapActions("publicationSections", ["getPublicationSectionsByOrg"]),
    ...mapMutations("notification", ["show", "hide"]),
    ...mapMutations("loader", ["loading", "loaded"]),
    handlePost(item) {
      Object.assign(this.publication, item);
    },
    addPollQuestion() {
      this.pollQuestions.push({ text: "", options: [""] });
    },
    removePollQuestion(questionIndex) {
      if (this.pollQuestions.length > 1) this.pollQuestions.splice(questionIndex, 1);
    },
    addPollOption(questionIndex) {
      this.pollQuestions[questionIndex].options.push("");
    },
    removePollOption(questionIndex, optionIndex) {
      const options = this.pollQuestions[questionIndex].options;
      if (options.length > 1) options.splice(optionIndex, 1);
    },
    normalizePollQuestions(questions) {
      if (!Array.isArray(questions) || !questions.length) return [{ text: "", options: [""] }];
      return questions.map((question) => ({
        text: question && question.text ? question.text : "",
        options: Array.isArray(question && question.options) && question.options.length
          ? question.options.map((option) => String(option || ""))
          : [""],
      }));
    },
    serializePollQuestions() {
      return this.pollQuestions.map((question) => ({
        text: question.text,
        options: question.options.filter((option) => option !== ""),
      }));
    },
    normalizeSectionId(section) {
      if (!section) return null;
      if (typeof section === "object") return section._id || section.id || null;
      return section;
    },
    async fetchSections() {
      const response = await this.getPublicationSectionsByOrg();
      this.publicationSections = response.status ? (response.data.sections || []) : [];
    },
    async fetchSubgroups() {
      try {
        const response = await axios.get("/subgroups/");
        this.subgroups = [
          ...this.subgroups,
          ...response.data.map((subgroup) => ({ text: subgroup.name, value: subgroup._id })),
        ];
      } catch (error) {
        console.error("Error fetching subgroups:", error);
      }
    },
    async fetchEmails() {
      try {
        const response = await axios.get("/subgroups/");

        if (this.selectedSubgroups.includes("Enviar a Todos")) {
          this.emails = response.data.flatMap((subgroup) =>
            subgroup.members.map((member) => member.email)
          );
        } else {
          this.emails = response.data
            .filter((subgroup) =>
              this.selectedSubgroups.includes(subgroup.name)
            )
            .flatMap((subgroup) =>
              subgroup.members.map((member) => member.email)
            );
        }

        return this.emails;
      } catch (error) {
        console.error("Error fetching emails:", error);
        this.show({
          color: "error",
          text: "Error al obtener los correos electrónicos.",
        });
        return [];
      }
    },

    mailToGroupSwitch() {
      return this.selectedOption === "sendEmailToGroups";
    },

    // onOptionChange() {
    //   if (this.mailToGroupSwitch()) {
    //     this.confirmDialog2 = false;
    //   } else {
    //     this.selectedSubgroups = [];
    //   }
    // },
    // confirmYes() {
    //   this.confirmDialog2 = false;
    //   this.selectedOption = "sendEmailNotification";
    //   this.confirmOption = true;
    // },
    // confirmNo() {
    //   if (this.confirmOption == true) {
    //     this.confirmDialog2 = false;
    //   } else {
    //     this.selectedOption = "cancelNotification";
    //     this.confirmDialog2 = false;
    //   }
    // },

    handleChangePost({ property, value }) {
      this.$set(this.publication, property, value);
    },

    youtubeCut(youtube) {
      let youtubeId = "";

      if (youtube.startsWith("https://youtu.be/")) {
        youtubeId = youtube.split("https://youtu.be/")[1];
      } else {
        if (youtube.includes("?v=")) {
          youtubeId = youtube.split("?v=")[1];
        } else if (youtube.includes("&v=")) {
          youtubeId = youtube.split("&v=")[1];
        }
      }
      youtubeId = youtubeId.split("&")[0];
      return `https://www.youtube.com/embed/${youtubeId}`;
    },

    async savePublication() {
      if (this.publication.type === "POLL") {
        this.publication.asocoinsSurvey.questions = this.serializePollQuestions();
      }
      try {
        this.loading();
        this.publication.section = this.normalizeSectionId(this.publication.section);
        if (
          this.publication.type === "DOC" &&
          this.publication.value &&
          typeof this.publication.value === "object" &&
          this.publication.value.type
        ) {
          let formData = new FormData();
          formData.append("file", this.publication.value);
          formData.append("publicationId", this.publication._id);
          formData.append("publicationType", this.publication.type);
          const fileResponse = await this.axios.put(
            "/publications/upload-image",
            formData
          );
          const uploadedImages = fileResponse.data.publication.images || [];
          this.publication.images = uploadedImages;
          this.publication.value =
            uploadedImages.slice(-1)[0];
        }

        let response = await this.updatePublication(this.publication);
        if (response.status) {
          if (this.publication.type === "POLL") {
            const surveyConfig = await this.configureSurvey({
              publicationId: this.publication._id,
              payload: {
                enabled: this.publication.asocoinsSurvey.enabled,
                baseAmount: this.publication.asocoinsSurvey.baseAmount,
                ruleCode: "SURVEY",
                startsAt: this.publication.asocoinsSurvey.startsAt || null,
                closesAt: this.publication.asocoinsSurvey.closesAt || null,
                questions: this.publication.asocoinsSurvey.questions,
              },
            });
            if (!surveyConfig.status) throw new Error(surveyConfig.message);
          }
          this.saveAction = true;
          this.show({
            time: 3000,
            color: "success",
            text: `Se ha ${
              this.mode === "CREATE" ? "guardado" : "actualizado"
            } los datos de la publicación`,
          });

        const response = await this.updatePublication({
          ...publicationPayload,
          _id: this.publication._id,
        });
        if (!response.status) {
          const message = response.message?.response?.data?.error?.message;
          throw new Error(message || "No se pudo guardar la publicación");
        }

        this.saveAction = true;
        this.show({
          time: 3000,
          color: "success",
          text: `Se ha ${
            this.mode === "CREATE" ? "guardado" : "actualizado"
          } los datos de la publicación`,
        });

        await this.$_sendEmailNotifications();
        await this.$_setPublicationRules();
       }
      } catch (error) {
        console.error("Error al guardar la publicación:", error);
        this.show({
          time: 3000,
          color: "error",
          text: error.message || "Error al guardar los cambios",
        });
      } finally {
        this.loaded();
        this.closeWindow();
      }
    },

    async $_sendEmailNotifications() {
      let selectedSubgroups = [...this.selectedSubgroups];
      try {
        if (selectedSubgroups.length > 0) {
          await this.axios.post("/users/send-publication-notification", {
            publicationTitle: this.publication.name,
            subgroups: selectedSubgroups.map((subgroup) => subgroup.value),
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    async $_setPublicationRules() {
      try {
          if (this.mode === "CREATE") {
            await this.$refs.audience_configs.createRules({
              publication: this.publication._id
            });
          } else {
            await this.$refs.audience_configs.updateRules({
              publication: this.publication._id
            });
          }
      } catch (error) {
        console.log(error)
      }
    },

    closePreview() {
      this.previewDialog = false;
    },

    closeWindow() {
      setTimeout(() => {
        this.$router.push({
          name: "myCommunity",
        });
      }, 2000);
    },

    async deleteOrganizationPublication(item) {
      const { name, description, value, type } = this.publication;
      try {
        if (
          name === "" ||
          description === "" ||
          (type == "BLOG" && value.includes["<p></p>"]) ||
          value == ""
        ) {
          this.loading();
          await this.deletePublication(item);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loaded();
        this.closeWindow();
      }
    },
  },
  computed: {
    ...mapState("publications", ["publicationId", "mode"]),
    ...mapState("user", ["user"]),
    hasChapters() {
      return hasOrganizationChapters(this.user);
    },
    setPublicationStatus: {
      get() {
        return this.publication.status === "PUBLISHED" ? true : false;
      },
      set(value) {
        value
          ? (this.publication.status = "PUBLISHED")
          : (this.publication.status = "DRAFT");
      },
    },
    setPublicationType() {
      return this.publication.type;
    },

    disableSaveButton() {
      return !(this.publication.name !== "");
    },

    publicationComputed() {
      return this.publication;
    },
    publicationSectionOptions() {
      return [{ _id: null, name: "Sin sección" }, ...this.publicationSections];
    },
  },
  watch: {
    selectedOption(newOption) {
      if (newOption == "sendToEveryone") {
        this.selectedSubgroups = [{ text: "Enviar a Todos los miembros", value: "sendEveryone" }];
      } else if (newOption == "cancelNotification" || newOption == "sendEmailToGroups") {
        this.selectedSubgroups = [];
      }
    },
  },
  // beforeDestroy() {
  //   if (this.saveAction==false) {
  //       this.deleteOrganizationPublication(this.publication)
  //   }
  // },

  async mounted() {
    console.log(this.publicationId, this.mode);
    try {
      this.loading();
      const postId = this.publicationId;
      if (postId) {
        let response = await this.fetchPublicationById(postId);
        this.publication = Object.assign(this.publication, {
          ...response.data,
          url: "",
          section: this.normalizeSectionId(response.data.section),
          asocoinsSurvey: {
            ...this.publication.asocoinsSurvey,
            ...(response.data.asocoinsSurvey || {}),
          },
        });
        this.pollQuestions = this.normalizePollQuestions(this.publication.asocoinsSurvey.questions);
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.loaded();
    }
  },
};
</script>

<style lang="scss" scoped>
.subtitle {
  font-weight: 600;
}

.section {
  margin-bottom: 20px;
}

.section > :nth-child(2) {
  margin-inline: 10px;
}
.drop-zone {
  width: 400px;
  height: 150px;
  border: 2px dashed rgb(149, 227, 253);
  display: flex;
  justify-content: center;
  align-items: center;
}

.asocoins-poll-editor {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  padding: var(--space-6);
  color: var(--color-text);
}

.asocoins-poll-editor__header h2,
.asocoins-poll-editor__header p {
  margin: 0;
}

.asocoins-poll-editor__header h2 {
  color: var(--color-navy-deep);
  font-family: var(--font-headline);
  font-size: var(--fs-display-md);
}

.asocoins-poll-editor__header p:last-child {
  margin-top: var(--space-2);
  color: var(--color-text-muted);
  line-height: 1.5;
}

.asocoins-poll-editor__eyebrow {
  margin-bottom: var(--space-1) !important;
  color: var(--color-amber-on);
  font-size: var(--fs-caption);
  font-weight: var(--fw-semibold);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.asocoins-poll-editor__field {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  color: var(--color-navy-deep);
  font-size: var(--fs-label-lg);
  font-weight: var(--fw-semibold);
}

.asocoins-poll-editor__field input,
.asocoins-poll-editor__field textarea {
  width: 100%;
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-md);
  background: var(--color-surface);
  padding: var(--space-3);
  color: var(--color-text);
  font: inherit;
  font-size: var(--fs-body-sm);
  font-weight: var(--fw-regular);
}

.asocoins-poll-editor__field textarea {
  min-height: 88px;
  resize: vertical;
  line-height: 1.5;
}

.asocoins-poll-editor__field input:focus,
.asocoins-poll-editor__field textarea:focus {
  outline: 3px solid var(--color-primary-soft);
  border-color: var(--color-navy-light);
}

.asocoins-poll-editor__field small {
  color: var(--color-text-muted);
  font-size: var(--fs-caption);
  font-weight: var(--fw-regular);
  line-height: 1.4;
}

.asocoins-poll-editor__questions {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.asocoins-poll-editor__questions-head,
.asocoins-poll-editor__options-head,
.asocoins-poll-editor__question-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.asocoins-poll-editor__questions-head {
  align-items: flex-end;
}

.asocoins-poll-editor__label,
.asocoins-poll-editor__options-head,
.asocoins-poll-editor__question-head {
  color: var(--color-navy-deep);
  font-size: var(--fs-label-lg);
  font-weight: var(--fw-semibold);
}

.asocoins-poll-editor__questions-head small {
  display: block;
  margin-top: var(--space-1);
  color: var(--color-text-muted);
  font-size: var(--fs-caption);
  font-weight: var(--fw-regular);
}

.asocoins-poll-editor__question {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface-low);
  padding: var(--space-4);
}

.asocoins-poll-editor__question-head {
  font-size: var(--fs-body-sm);
}

.asocoins-poll-editor__options {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  border-top: 1px solid var(--color-border);
  padding-top: var(--space-4);
}

.asocoins-poll-editor__options-head {
  font-size: var(--fs-body-sm);
}

.asocoins-poll-editor__option {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.asocoins-poll-editor__option input {
  flex: 1;
}

.asocoins-poll-editor__button,
.asocoins-poll-editor__remove {
  border: 0;
  background: transparent;
  color: var(--color-navy-light);
  cursor: pointer;
  font: inherit;
  font-size: var(--fs-body-sm);
  font-weight: var(--fw-semibold);
  white-space: nowrap;
}

.asocoins-poll-editor__button:hover,
.asocoins-poll-editor__remove:hover {
  color: var(--color-amber-hover);
}

.asocoins-poll-editor__button--small {
  font-size: var(--fs-caption);
}

.asocoins-poll-editor__remove {
  color: var(--color-text-muted);
  font-size: var(--fs-caption);
}

.asocoins-poll-editor__option .asocoins-poll-editor__remove {
  width: 28px;
  height: 28px;
  color: var(--color-text-muted);
  font-size: var(--fs-display-sm);
  line-height: 1;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.asocoins-poll-editor__check {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  color: var(--color-navy-deep);
  font-size: var(--fs-body-sm);
  font-weight: var(--fw-semibold);
}

.asocoins-poll-editor__check input {
  width: 18px;
  height: 18px;
  accent-color: var(--color-amber);
}

.asocoins-poll-editor__reward {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  border-left: 3px solid var(--color-amber);
  border-radius: var(--radius-sm);
  background: var(--color-surface-low);
  padding: var(--space-4);
}

.asocoins-poll-editor__dates {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-4);
}

@media (max-width: 720px) {
  .asocoins-poll-editor__dates {
    grid-template-columns: 1fr;
  }
}
</style>

